import React, { useState, useEffect, Fragment } from "react";
import { getUbicacionesGrupo } from "../repository";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";
import LocationItem from "../components/LocationItem";

const Locations = () => {
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState(null);
  const [loading, setLoading] = useState(true);

  const obtieneGrupos = () => {
    setLoading(true);
    getUbicacionesGrupo()
      .then((response) => {
        if (response.status === 200) {
          const data = response.data.result;
          setGrupos(data);
          // Seleccionar el primer grupo (filtrado o no)
          const filteredData = data.filter(
            (item) => item.Grupo.toUpperCase() !== "CENTROS DE DISTRIBUCIÓN"
          );
          if (filteredData.length > 0) {
            setSelectedGrupo(filteredData[0].OrdenGrupo);
          } else if (data.length > 0) {
            // Si solo existe "CENTROS DE DISTRIBUCIÓN", seleccionarlo
            setSelectedGrupo(data[0].OrdenGrupo);
          }
        } else {
          setGrupos([]);
        }
      })
      .catch(() => {
        setGrupos([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    obtieneGrupos();
  }, []);

  const handleGrupoClick = (ordenGrupo) => {
    setSelectedGrupo(ordenGrupo);
  };

  const formatGrupoName = (nombre) => {
    return nombre.replace("ÁREA METROPOLITANA MONTERREY", "ÁREA METROPOLITANA MTY");
  };

  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="cedis-hero">
        <div className="container">
          <div className="cedis-hero-content">
            <h1 className="cedis-hero-title">Centros de Distribución</h1>
            <p className="cedis-hero-subtitle">
              Encuentra tu CEDIS más cercano
            </p>
          </div>
        </div>
      </div>

      {/* Sección de Ubicaciones */}
      <div className="cedis-section">
        <div className="container">
          {loading ? (
            <div className="cedis-loading">
              <div className="spinner-border text-warning" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
              <p>Cargando ubicaciones...</p>
            </div>
          ) : (
            <Fragment>
              {/* Navegación de Regiones - solo mostrar si hay más de un grupo */}
              {grupos.filter((item) => item.Grupo.toUpperCase() !== "CENTROS DE DISTRIBUCIÓN").length > 0 && (
                <div className="cedis-region-nav">
                  {grupos
                    .filter((item) => item.Grupo.toUpperCase() !== "CENTROS DE DISTRIBUCIÓN")
                    .map((item) => (
                      <button
                        key={item.OrdenGrupo}
                        className={`region-chip ${selectedGrupo === item.OrdenGrupo ? "active" : ""}`}
                        onClick={() => handleGrupoClick(item.OrdenGrupo)}
                      >
                        {formatGrupoName(item.Grupo)}
                      </button>
                    ))}
                </div>
              )}

              {/* Contenido de Sucursales */}
              <div className="cedis-content">
                {selectedGrupo && (
                  <LocationItem ordenGrupo={selectedGrupo} />
                )}
              </div>
            </Fragment>
          )}
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default Locations;
